import { formatPct, formatUsd } from '~/utils/format'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('formatUSD', formatUsd)
  nuxtApp.provide('formatPct', formatPct)
})
